// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_vat_included = /** @type {(inputs: {}) => string} */ () => {
	return `VAT (included)`
};

const el_vat_included = /** @type {(inputs: {}) => string} */ () => {
	return `ΦΠΑ (συμπεριλαμβάνεται)`
};

const ru_vat_included = /** @type {(inputs: {}) => string} */ () => {
	return `НДС (включён)`
};

const he_vat_included = /** @type {(inputs: {}) => string} */ () => {
	return `מע״מ (כלול)`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const vat_included = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.vat_included(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("vat_included", locale)
	if (locale === "en") return en_vat_included(inputs)
	if (locale === "el") return el_vat_included(inputs)
	if (locale === "ru") return ru_vat_included(inputs)
	if (locale === "he") return he_vat_included(inputs)
	return "vat_included"
};